import { RefObject } from 'react';

export function useCollapseOnOutsideFocus(rootRef: RefObject<HTMLElement | null>, onCollapse: () => void) {
  return () => {
    window.setTimeout(() => {
      if (rootRef.current && !rootRef.current.contains(document.activeElement)) {
        onCollapse();
      }
    }, 0);
  };
}
